module.exports = __webpack_public_path__ + "static/img/security1.a7bfe151.png";